"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDisbursementresultCode = void 0;
var IDisbursementresultCode;
(function (IDisbursementresultCode) {
    IDisbursementresultCode["THE_DISBURSEMENT_IS_CURRENTLY_PENDING_PENDING"] = "pending";
    IDisbursementresultCode["THE_DISBURSEMENT_FAILED_DUE_TO_AN_INTERNAL_ISSUE_INTERNAL"] = "internal";
    IDisbursementresultCode["THE_DISBURSEMENT_FAILED_DUE_TO_INSUFFICIENT_FUNDS_NSF_NSF"] = "nsf";
    IDisbursementresultCode["THE_DISBURSEMENT_FAILED_DUE_TO_INCORRECT_ACCOUNT_INFORMATION_BADACCOUNT"] = "badAccount";
    IDisbursementresultCode["THE_DISBURSEMENT_FAILED_BECAUSE_IT_WAS_UNAUTHORIZED_UNAUTHORIZED"] = "unauthorized";
    IDisbursementresultCode["THE_DISBURSEMENT_ENCOUNTERED_A_GENERAL_ISSUE_GENERAL"] = "general";
    IDisbursementresultCode["THERES_BEEN_A_NOTIFICATION_OF_CHANGE_NOC_FOR_THIS_DISBURSEMENT_NOC"] = "noc";
    IDisbursementresultCode["_PARAMETER"] = "parameter";
    IDisbursementresultCode["_SAMEDAY"] = "sameDay";
    IDisbursementresultCode["_TRANSFERDETAILS"] = "transferDetails";
    IDisbursementresultCode["_PLATFORM"] = "platform";
})(IDisbursementresultCode = exports.IDisbursementresultCode || (exports.IDisbursementresultCode = {}));
